export const APTOS_COIN = "0x1::aptos_coin::AptosCoin";
export const APTOS_SEPARATOR = "::";
//# sourceMappingURL=constants.js.map